// extracted by mini-css-extract-plugin
export default {"TakeoverModal":"TakeoverModal_TakeoverModal__hKOfn","Content":"TakeoverModal_Content__8mnO6","TakeoverModalHeader":"TakeoverModal_TakeoverModalHeader__nWqhC"};